import React from 'react';
import { Link } from '@reach/router';

import './style.scss';

const ServiceNotice = () => (
  <>
    {/* <div className="text-center freight-restrictions">
      <h3>Labor Day Freight Schedule</h3>
      <h4 className="mb-4">Click the button below to view the Labor Day Weekend freight times.</h4>
      <Link className="btn btn-primary" to="/info/freight/ldw">
        Labor Day Weekend Freight Info
      </Link>
    </div> */}
    <div className="text-center service-notice">
      <h3>Schedule Subject to Change Without Notice</h3>
      <h4>Service May Be Disrupted Due to Storms, Ice, and Tide Conditions</h4>
      <p>Any service updates or disruptions will be posted on our website as soon as those determinations are made.</p>
      {/* <div className="notice notice-important notice-small">
      <i className="fas fa-fire" /> No flammables or compressed gas containers
      (new or used) permitted on passenger boats.
    </div> */}
    </div>
  </>
);

export default ServiceNotice;
